<div class="new-channel-header">
  <span class="new-channel-title">New Channel</span>
</div>
<div class="new-channel-body">
  <div class="name-holder">
    <label class="padded-top-gray-label">Channel Name:</label>
    <input type="text" 
      class="normal-text-input" 
      [formControl]="channelName" 
      placeholder="Enter channel name"/>
  </div>
  <div class="dropdown-holder">
    <label class="padded-top-gray-label">Members:</label>
    <div
      class="normal-text-input dropdown-styled enter-members-field styled-scrolled"
      [ngClass]="{ 'opened' : userDialogOpened }"
      (click)="selectUserDialog()">
      <span *ngIf="!channelMembers.length">Enter members</span>
      <div class="member-chip" *ngFor="let member of channelMembers">
        <div class="member-chip-avatar">
          <app-user-avatar
            [firstname]="member.firstname"
            [lastname]="member.surname"
            [colour]="member.avatarColour"
            [fontSize]="'8px'">
          </app-user-avatar>
        </div>
        <div class="member-chip-name">{{ member.firstname }} {{ member.surname }}</div>
        <div class="member-chip-close-icon" (click)="removeMember(member, $event)">
          <img src="/assets/images/chat/chip-remove-icon.svg" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="new-channel-buttons">
  <button 
    class="btn btn-styled--secondary btn-block btn-select" 
    type="button"
    mat-dialog-close
    [disabled]="false">
    Cancel
  </button>
  <button class="btn btn-styled btn-block btn-select mx-2" type="button"
    [disabled]="!canCreateChannel"
    (click)="createChannel()">
    Create
  </button>
</div>
